import { get, post } from '../../../utils/api';

export default {
  getPromoSources: () => get({ url: 'promo/generate-coupon/sources' }),
  generateCoupon: params => post({ url: 'promo/generate-coupon', data: params }),
};
